<template>
  <div>
    <a-form :form="dealForm" layout="vertical">
      <div>
        <div class="statusRow">
          <div :class="dealTypeList[0].active ? 'statusSelected':'statusDefault'" @click="switchDealType(0)">{{$t('track.trackType.新设立')}}</div>
          <div :class="dealTypeList[1].active ? 'statusSelected':'statusDefault'" @click="switchDealType(1)">{{$t('track.trackType.搬迁')}}</div>
          <div :class="dealTypeList[2].active? 'statusSelected':'statusDefault'" @click="switchDealType(2)">{{$t('track.trackType.续租')}}</div>
          <div :class="dealTypeList[3].active ? 'statusSelected':'statusDefault'" @click="switchDealType(3)">{{$t('track.trackType.租约重构')}}</div>
          <div :class="dealTypeList[4].active ? 'statusSelected':'statusDefault'" @click="switchDealType(4)">{{$t('track.trackType.扩租')}}</div>
        </div>
        <add-lease :defaultRentUnit="defaultRentUnit" :defaultAreaUnit="defaultAreaUnit" @customerIdChange="customerIdChange"
                   :showAttachment="false"
                   ref="newLeaseRef" :defaultLeaseInfoVO="newLeaseInfoVO[0]"></add-lease>
      </div>
      <!--<div v-for="(item,index) in oldLeaseInfoVO" :key="index" class="lease_info">-->
        <!--<div class="lease_title">-->
          <!--{{$t('deal.addDeal.leaseContract.title')}}{{index+1}}-->
        <!--</div>-->
        <!--<div @click="showLease(item,index)">-->
          <!--<pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div style="margin: 10px 0;">-->
        <!--<pt-addTag @showButton="showLease" :text="$t('news.dealForm.leaseTitle')"></pt-addTag>-->
      <!--</div>-->
    </a-form>
    <pt-modal :title="$t('lease.modal.title')" :visible="oldRentInfoVisible"
              @ok="saveLease" @cancel="hideLease" :width="800"
    >
      <div slot="content">
        <add-lease :defaultCustomerId="defaultCustomerId"
          :defaultRentUnit="defaultRentUnit" :defaultAreaUnit="defaultAreaUnit" ref="oldLeaseRef" :defaultLeaseInfoVO="defaultLeaseInfoVO"></add-lease>
      </div>
    </pt-modal>
  </div>
</template>

<script>
  import customerApi from '@/api/mine/customer'
  import addLease from '@/views/database/lease/module/addLease'

  export default {
    name: 'dealForm',
    components:{
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },
      addLease
    },
    props:{
      defaultRentUnit:{
        type:String,
        default:null,
      },
      defaultAreaUnit:{
        type:String,
        default:null,
      },
      mansionList:{
        type:Array,
        default: []
      },
      newsDO:{
        type: Object,
        default:null
      }
    },
    data(){
      return{
        defaultCustomerId: null,
        editIndex:undefined,
        dealTypeList:[
          {key:'新设立',active:true},
          {key:'搬迁',active:false},
          {key:'续租',active:false},
          {key:'租约重构',active:false},
          {key:'扩租',active:false},
        ],
        leaseInfoDOS:this.newsDO ? JSON.parse(JSON.stringify(this.newsDO.leaseLeaseInfoTypeVOS)) : [],
        dealTypes:[],
        dealForm: this.$form.createForm(this),
        oldRentInfoVisible:false,
        defaultLeaseInfoVO:null,
        customerList:[],
        newFloor:[],
        oldFloor:[],
        customerModalVisible: false,

      }
    },
    mounted(){
      this.initDealTypes()
      this.initForm()
    },
    computed:{
      newLeaseInfoVO(){
        if(this.leaseInfoDOS){
          let arr = this.leaseInfoDOS.filter(e=>{
            return e.newLease == true
          }).map(f=>{return f.leaseLeaseInfoVO})
          return arr
        }else{
          return []
        }
      },
      oldLeaseInfoVO(){
        if(this.leaseInfoDOS){
            let arr = this.leaseInfoDOS.filter(e=>{
              return e.newLease == false
            })
          return arr
        }else{
          return []
        }
      }
    },
    methods:{
      customerIdChange(value){
        this.defaultCustomerId = value
      },
      switchDealType(item){
        this.dealTypeList[item].active =  !this.dealTypeList[item].active;
      },
      handleSearch(customerName){
        setTimeout(()=>{
          let this_ = this
          customerApi.queryByName({name: customerName}).then(res => {
            this_.customerList = res.data
          })
        },300);
      },
      hideLease(){
        this.oldRentInfoVisible = false
      },
      initDealTypes(){
        let dealTypes = this.$t('deal.dealTypes')
        for(var p in dealTypes){
          this.dealTypes.push({wordKey:p,wordValue:dealTypes['' + p]})
        }
      },
      initForm(){
        let newsDO = this.newsDO
        if(newsDO && newsDO.dealType){
          this.dealTypeList.forEach(e=>{
            if( newsDO.dealType.split(',').indexOf(e.key + '') >= 0){
              e.active = true
            }else{
              e.active = false
            }
          })
        }
        this.dealForm.setFieldsValue(this.newsDO)
      },
      openAddCustomerModal(){
        this.customerModalVisible = true;
      },
      saveLease(){
        let leaseInfoVO = this.$refs.oldLeaseRef.extractLeaseInfoVO()
        if(!leaseInfoVO){
          return
        }
        if(this.defaultLeaseInfoVO){
          this.$set(this.leaseInfoDOS[this.editIndex],'leaseLeaseInfoVO', leaseInfoVO)
        }else{
          this.leaseInfoDOS.push({newLease:false, leaseLeaseInfoVO: leaseInfoVO})
        }
        this.hideLease()
      },
      showLease(leaseInfoVO,index){
        this.oldRentInfoVisible = true
        if(leaseInfoVO == undefined || leaseInfoVO == null){
          this.defaultLeaseInfoVO = null;
        }else{
          this.defaultLeaseInfoVO = leaseInfoVO.leaseLeaseInfoVO
        }
        this.editIndex = index
      },
      submit(){
        let newLeaseInfoVO = this.$refs.newLeaseRef.extractLeaseInfoVO()
        if(newLeaseInfoVO){
          let leaseInfoTypeVO = {newLease:true, leaseLeaseInfoVO: newLeaseInfoVO}
          let newsVO = this.dealForm.getFieldsValue()
          newsVO.leaseLeaseInfoTypeVOS = [...(this.oldLeaseInfoVO),leaseInfoTypeVO]
          newsVO.dealType = this.dealTypeList.filter(e=>{
            return e.active
          }).map(b=>{return b.key}).join(',')
          return newsVO
        }else{
          return false;
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .statusRow{
    display: flex;
    flex-direction: row;
    align-items: center;
    background: rgba(248,249,251,0.62);;
    padding: 40px 20px 20px 20px;
    .statusSelected{
      transition: background-color .15s ease-in-out;
      background: #FABE00;
      border-radius: 4px;
      /*width: 90px;*/
      padding: 0 12px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      cursor: pointer;
      margin-right: 28px;
    }
    .statusDefault{
      transition: background-color .15s ease-in-out;
      background: #FFFFFF;
      border-radius: 4px;
      padding: 0 12px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      cursor: pointer;
      margin-right: 28px;
    }
  }
  .expandMoreBtn{
    background: #E8E8E8;
    border: 1px solid #DFDFDF;
    border-radius: 2px;
    height: 25px;
    line-height: 25px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    cursor:pointer;
    margin-bottom: 5px;
    display: inline-block;
    margin-left: 20px;
    .expandIcon{
      font-size: 12px;
    }
    .expandMoreText{
      display: inline;
      margin-left: 5px;
      font-size: 12px;
      color: #666666;
    }
  }
  .expandDiv{
    margin-bottom: 20px;
    .expandMoreDiv{
      margin: 0 14px;
      padding: 20px 10px 0px 10px;
      background: #F2F4F6;
      border-radius: 2px;
      position: relative;
    }
    .closeExpandBtn{
      position: absolute;
      right: 0px;
      top:0px;
      width: 24px;
      height: 24px;
      border-radius:2px;
      background: #D3D3D3;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      .closeIcon{
        font-size: 14px;
        color: #FFFFFF;
      }
    }
    .expandTitle{
      margin-left: 20px;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin-bottom: 4px;
    }
  }
    .addCustomerBtn{
      background: #3B2E26;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      height: 30px;
      .addIcon{
        color: #ffffff;
        font-size: 12px;
      }
    }
  .lease_info{
    margin-top: 10px;
    display: flex;
    .lease_title{
      flex: 1;
      font-size: 14px;
      color: #333333;
      font-weight: bold;
    }
    position: relative;
    margin-bottom: 5px;
    background: rgba(248,249,251,0.62);
    padding: 10px 20px;
    .edit_icon{
      font-size: 18px;
    }
  }
</style>